<template>
  <div class="container">
    <div class="check-work-attendance-body">
      <el-row>
        <el-col :span="24"
          ><div class="grid-content bg-purple-dark">
            <el-form
              size="small"
              :inline="true"
              :model="formInline"
              class="demo-form-inline"
            >
              <el-form-item label="时间范围">
                <el-date-picker
                  v-model="timeScope"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="dateChange"
                  :picker-options="pickerOptions"
                  value-format="yyyy-MM-dd"
                  placement="bottom-start"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item label="签到状态">
                <el-select
                  v-model="formInline.signState"
                  placeholder="请选择查询类型"
                >
                  <el-option label="已签到" value="true"></el-option>
                  <el-option label="缺勤" value="false"></el-option>
                  <el-option label="未知" value=""></el-option>
                </el-select>
              </el-form-item>

              <el-form-item>
                <el-input
                  placeholder="请输入内容"
                  v-model="formInline.class_search_value"
                  class="input-with-select"
                >
                  <el-select
                    v-model="formInline.class_search_type"
                    slot="prepend"
                    style="width: 110px"
                  >
                    <el-option label="班级名称" value="1"></el-option>
                    <el-option label="班级码" value="2"></el-option>
                    <el-option label="教师姓名" value="3"></el-option>
                  </el-select>
                </el-input>
              </el-form-item>

              <el-form-item label="学员姓名">
                <el-input
                  v-model="formInline.student_user_nickname"
                  placeholder="请输入学员姓名"
                ></el-input>
              </el-form-item>

              <el-form-item label="学生账号">
                <el-input
                  v-model="formInline.student_name"
                  placeholder="请输入学生账号"
                ></el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
                <el-button @click="reSize">重置</el-button>
              </el-form-item>
            </el-form>
          </div></el-col
        >
      </el-row>

      <el-divider></el-divider>

      <el-row>
        <el-col :span="24"
          ><div class="absence">
            <el-table
              size="small"
              :data="tableData"
              style="width: 100%"
              :header-cell-style="{ background: '#f5f7fa' }"
            >
              <el-table-column
                fixed="left"
                sortable
                align="center"
                prop="created_time"
                label="讲次日期"
                width="150"
              ></el-table-column>

              <el-table-column
                align="center"
                prop="title"
                label="讲次名称"
                width="150"
              ></el-table-column>

              <el-table-column
                align="center"
                prop="date"
                label="学员姓名"
                width="100"
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="name"
                label="班级名称"
                width="150"
              ></el-table-column>

              <el-table-column
                width="150"
                align="center"
                prop="subject_name"
                label="授课时段"
              ></el-table-column>

              <el-table-column align="center" prop="date" label="上课老师">
              </el-table-column>

              <el-table-column
                align="center"
                prop="is_sign"
                label="考勤状态"
              ></el-table-column>

              <el-table-column
                align="center"
                prop="sign_date"
                label="签到时间"
                width="150"
              >
              </el-table-column>

              <el-table-column
                align="center"
                prop="resign_date"
                label="补签时间"
                width="150"
              >
              </el-table-column>
            </el-table></div
        ></el-col>
      </el-row>

      <div class="pagination-style">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page_no"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getSignClassList } from '@/api/educational'

export default {
  name: 'checkWorkAttendance',
  data() {
    return {
      tableData: [],
      //出勤查询数据
      formInline: {
        start_time: '',
        end_time: '',
        signState: 'false',
        class_search_type: '1',
        class_search_value: '',
        student_user_nickname: '',
        student_name: '',
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      timeScope: '',
      page_no: '1',
      page_size: '20',
      total: 0,
    }
  },
  mounted() {
    this.getSignClassList()
  },
  methods: {
    //查询出勤数据
    getSignClassList() {
      console.log('程序启动')
      console.log(this.formInline)
      getSignClassList({
        start_time: this.formInline.start_time,
        end_time: this.formInline.end_time,
        signState: this.formInline.signState,
        class_search_type: this.formInline.class_search_type,
        class_search_value: this.formInline.class_search_type,
        student_user_nickname: this.formInline.student_user_nickname,
        student_name: this.formInline.student_name,
      }).then((res) => {
        console.log('出勤数据')
        console.log(res)
        this.tableData = res.signClassList
        this.total = res.total
      })
    },

    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.page_no = val
    },
    reSize() {
      console.log('重置')
    },
    onSubmit() {
      console.log('提交查询')
      console.log(this.formInline)
      this.getSignClassList()
    },
    handleSizeChange() {},
    dateChange(val) {
      console.log('日期变化')
      console.log(val)
      this.formInline.start_time = val.toString().split(',')[0]
      this.formInline.end_time = val.toString().split(',')[1]
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  margin: 15px;
  height: 100%;
  min-width: 1000px;
  overflow: hidden;
  .check-work-attendance-body {
    border-radius: 5px;
    padding: 20px;
    background-color: #ffffff;
  }
}
</style>
